const initialState = {};

export default function (state = initialState, action = {} ){
    switch(action.type){
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./common/reducers/Props.js